import React, { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Router } from '../../router/Router';
import { NumberSlider } from '../../components/NumberSlider';
import { Store } from '../../models/StoresResponse';
import { checkStore } from '../../helpers/CheckStore';
import { formatByTemplate } from '../../helpers/date';
import { User } from '../../models/User';
import { CSDProvider } from '../../components/CSDProvider';

export const Balance: FC = () => {
  const router = Router(useNavigate());

  const [selectedStore] = useState<Store>(checkStore());
  const [user, setUser] = useState<User>();

  const handleCancel = () => {
    localStorage.removeItem('user');
    router.goToWelcomeCSD();
  };

  const handleAccept = () => {
    if (user !== undefined) {
      if (user.balance <= 0) {
        handleCancel();
        return;
      }
      router.goToRepresentativeConfirmation();
    }
  };

  const checkSelectedStore = () => {
    if (selectedStore === undefined) {
      router.goToStore();
      return;
    }
    const retrievedUser = localStorage.getItem('user');
    if (retrievedUser !== null) {
      setUser(JSON.parse(retrievedUser));
    }
  };

  useEffect(() => {
    checkSelectedStore();
  }, []);

  return (
    <CSDProvider>
      <div className="container-fluid-background">
        <div className="row Navbar">
          <div className="col my-auto">
            <p className="my-auto" style={{ color: 'white' }}>
              <span style={{ fontWeight: 'bold' }}>OLYNS</span> - {`${selectedStore?.company} ${selectedStore?.name}`.toUpperCase()}
            </p>
          </div>
          <div className="col my-auto text-center">
            <p className="my-auto" style={{ color: 'white', fontWeight: 'bold' }}>GET CASH</p>
          </div>
          <div className="col my-auto text-end">
            <p className="my-auto" style={{ color: 'white' }}>{formatByTemplate(new Date(), 'hh:mmA, MMMM DD').toUpperCase()}</p>
          </div>
        </div>

        <div
          className="row"
          style={{
            height: '90vh', display: 'flex', alignItems: 'center', overflowY: 'auto',
          }}
        >
          <div className="col text-center" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <NumberSlider slide={1} />

            <div className="WhiteContainerNoPadding">
              <div className="GradientBG">
                <span>HI {user?.first_name.toUpperCase()}!</span>
                <br />
                <span>THIS IS YOUR BALANCE</span>
              </div>
              <p className="Balance">${user?.balance.toFixed(2)}</p>
            </div>

            <button type="button" className="btn AcceptButton" onClick={handleAccept}>Accept</button>
            <button type="button" className="btn CancelButton" onClick={handleCancel}>Cancel</button>
          </div>
        </div>

      </div>
    </CSDProvider>
  );
};
